import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Checkbox, Header } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import { ReportsAccessType, UserReportsEvent, UserReportsPromoter } from '../AdminClasses';
import { Link } from 'react-router-dom';
import { useUser } from '../AdminHooks';
import API from '../API';
import UserAccess from '../UserAccess';

interface UserReportsAccessModalProps{
	open: boolean,
	title?: string,
	onClose: ()=>void,
	event: UserReportsEvent,
	onEventEdit: (event: UserReportsEvent)=>void,
	promoter: UserReportsPromoter,
	onPromoterEdit: (promoter: UserReportsPromoter)=>void,
}

var UserReportsAccessModal = (props: UserReportsAccessModalProps)=>{
	var { t } = useTranslation();
	var { hasAccess } = useUser();
	var [allAccess, setAllAccess] = useState<ReportsAccessType[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [access, setAccess] = useState<number[]>(null);

	useEffect(()=>{
		if(!props.open){
			setAccess(null);
		}else if(props.promoter){
			setAccess(props.promoter.access);
		}else if(props.event){
			setAccess(props.event.access);
		}
	}, [props.open, props.event, props.promoter]);

	useEffect(()=>{
		if(props.open && !allAccess){
			setLoadError(null);
			API.getAllReportsAccess().then(res=>{
				if(res.error) return setLoadError(res.message);
				setAllAccess(res.data);
			}).catch(err=>{
				return setLoadError(t('common.unexpected_code', { code: 'CMP-USRPACMD-1' }));
			})
		}
	}, [allAccess, props.open]);

	var onAccessChange = (access_id: number)=>{
		return (val: boolean)=>{
			if(!val){
				setAccess(access ? access.filter(a=>a!==access_id) : []);
			}else{
				setAccess([
					...access,
					access_id
				]);
			}
		}
	}

	var save = ()=>{
		if(props.event){
			if(!props.onEventEdit) return;
			props.onEventEdit({
				...props.event,
				access,
			})
		}else if(props.promoter){
			if(!props.onPromoterEdit) return;
			props.onPromoterEdit({
				...props.promoter,
				access,
			})
		}
	}

	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header>{props.title || (props.event ? 'Editar acceso evento' : props.promoter ? 'Editar acceso promotor' : 'Acceso usuario')}</Modal.Header>
		<Modal.Content>
			<Table details fitted top>
				<Table.Body data={[
					['ID', (props.event?.event_id || props.promoter?.promoter_id)],
					['Nombre', <>
						{(props.event?.event_name || props.promoter?.promoter_name)}
						<div className="meta">
							<Button size='tiny' style={{ minWidth: 50 }} iconName='external-link' as={Link} to={props.event ? `/events/${props.event.event_id}` : (props.promoter ? `/promoters/${props.promoter.promoter_id}` : null)} target='_blank' />
						</div>
					</>],
				]} />
			</Table>
			<div style={{ backgroundColor: '#f9fafb', fontSize: 16, padding: '10px 15px', fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', margin: '0 -20px 15px -20px' }}>
				Accesos
			</div>
			{loadError ? (
				<Header text={'Error'} subtext={loadError} />
			) : !allAccess ? (
				<Header loading text={'Cargando accesos'} size='normal' style={{ fontSize: 16 }} />
			) : (
				allAccess.map(a=>(
					<Checkbox key={`USRPAC-${a.access_id}`} style={{ marginBottom: 5 }} label={<>
						{hasAccess(UserAccess.ADMIN.DEVELOPER) && (
							<span style={{ color: 'gray', marginRight: 5 }}>[{a.access_id}]</span>
						)}
						{a.access_name}
					</>} checked={access?.indexOf(a.access_id)!=-1} onChange={onAccessChange(a.access_id)} />
				))
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button onClick={props.onClose} text='Cancelar' basic />
			<Button onClick={save} color='black' disabled={access?.length==0} text='Guardar' />
		</Modal.Actions>
	</Modal>
}

export default UserReportsAccessModal;